import React from 'react';
import PropTypes from 'prop-types';

const IconHelp = ({ className }) => (
    <svg
      width="37px"
      height="33px"
      viewBox="0 0 37 33"
      version="1.1"
      className={className}
      xmlns="http://www.w3.org/2000/svg"
    >
      <g stroke="none" strokeWidth="1" fill="none" fillRule="evenodd">
        <g
          transform="translate(-1380.000000, -2918.000000)"
          fill="#27919C"
          fillRule="nonzero"
        >
          <g
            id="KSP/CustomerService"
            transform="translate(1380.000000, 2917.000000)"
          >
            <path
              d="M31.69995,1.875 C34.1467703,1.875 36.12945,3.85767966 36.12945,6.3045 L36.12945,27.414 C36.12945,29.4705781 33.6503786,30.5105513 32.1848639,29.0683447 L30.5222514,27.4342422 C29.582065,26.5087654 28.3129685,25.989 26.99295,25.989 L25.318,25.988 L25.3185,26.86935 C25.3185,28.9004983 23.7428529,30.5662616 21.7519276,30.6683883 L21.558,30.67335 L7.8915,30.67335 C6.90147388,30.67335 5.94928263,31.0697152 5.23999513,31.7778451 L5.23999513,31.7778451 L3.91549513,33.1023451 C2.59839816,34.4194421 0.375,33.4696287 0.375,31.61535 L0.375,31.61535 L0.375,14.49585 C0.375,12.3991808 2.05394134,10.69185 4.1355,10.69185 L4.1355,10.69185 L5.434,10.691 L5.43495,6.3045 C5.43495,3.85811863 7.41869049,1.875 9.86445,1.875 L31.69995,1.875 Z M5.434,12.941 L4.1355,12.94185 C3.30510507,12.94185 2.625,13.6334551 2.625,14.49585 L2.625,14.49585 L2.625,31.2108599 L3.64965452,30.1862058 C4.7802125,29.0574921 6.30361689,28.42335 7.8915,28.42335 L7.8915,28.42335 L21.558,28.42335 C22.3883949,28.42335 23.0685,27.7317449 23.0685,26.86935 L23.0685,26.86935 L23.068,25.988 L9.86445,25.989 C7.41900147,25.989 5.43495,24.0061924 5.43495,21.561 L5.434,12.941 Z M31.69995,4.125 L9.86445,4.125 C8.66117329,4.125 7.68495,5.10091726 7.68495,6.3045 L7.68575898,11.5268173 C7.71037859,11.6193481 7.7235,11.7165667 7.7235,11.81685 C7.7235,11.9171333 7.71037859,12.0143519 7.68575898,12.1068827 L7.68495,21.561 C7.68495,22.7632358 8.66132638,23.739 9.86445,23.739 L26.99295,23.739 C28.9035282,23.739 30.7395476,24.4909517 32.1000361,25.8301553 L33.7625431,27.4641539 C33.8055165,27.5064439 33.87945,27.4754287 33.87945,27.414 L33.87945,6.3045 C33.87945,5.10032034 32.9041297,4.125 31.69995,4.125 Z M27.7713,17.3643 L27.7713,19.6143 L12.4548,19.6143 L12.4548,17.3643 L27.7713,17.3643 Z M27.7713,12.91695 L27.7713,15.16695 L12.4548,15.16695 L12.4548,12.91695 L27.7713,12.91695 Z M27.7713,8.5473 L27.7713,10.7973 L12.4548,10.7973 L12.4548,8.5473 L27.7713,8.5473 Z"
              id="CustomerService"
            />
          </g>
        </g>
      </g>
    </svg>
  );

IconHelp.propTypes = {
  className: PropTypes.string
}

export default IconHelp;
